(() => {
  if (window.O7CertificateAnalysis) return;
  window.O7CertificateAnalysis = true;

  const closeDialog = (dialog) => {
    if (!dialog) return;
    const frame = dialog.querySelector("[data-cert-frame]");
    if (dialog.open && typeof dialog.close === "function") dialog.close();
    if (frame) frame.removeAttribute("src");
  };

  const openDialog = (button) => {
    const section = button.closest("[data-cert-section]");
    const dialog = section && section.querySelector("[data-cert-dialog]");
    if (!dialog) return;

    const frame = dialog.querySelector("[data-cert-frame]");
    const title = dialog.querySelector("[data-cert-dialog-title]");
    const fallback = dialog.querySelector("[data-cert-fallback]");
    const pdf = button.getAttribute("data-pdf");
    if (!pdf || !frame) return;

    if (title) title.textContent = button.getAttribute("data-title") || "Certificate";
    if (fallback) fallback.href = pdf;
    frame.src = pdf;

    if (typeof dialog.showModal === "function") dialog.showModal();
    else dialog.setAttribute("open", "");
  };

  document.addEventListener("click", (event) => {
    const opener = event.target.closest("[data-cert-open]");
    if (opener) {
      event.preventDefault();
      openDialog(opener);
      return;
    }

    const closer = event.target.closest("[data-cert-close]");
    if (closer) {
      closeDialog(closer.closest("[data-cert-dialog]"));
    }
  });

  document.addEventListener("click", (event) => {
    const dialog = event.target.closest("[data-cert-dialog]");
    if (!dialog || event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    const inside =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
    if (!inside) closeDialog(dialog);
  });

  document.addEventListener("close", (event) => {
    const dialog = event.target;
    if (!dialog.matches || !dialog.matches("[data-cert-dialog]")) return;
    const frame = dialog.querySelector("[data-cert-frame]");
    if (frame) frame.removeAttribute("src");
  }, true);
})();
